import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import logo from '../assets/images/logo.webp';
import { Link } from 'react-router-dom';
const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      <footer>
        <div className='container-fluid2'>
          <Row>
            <Col sm={12} xs={12} md={12} lg={4}>
              <div className="footer-box text-center">
                <Image src={logo} alt="sakhi log" className="" style={{ width: "25%" }}  loading="lazy"/>
                <h4 className='pt-4 pb-2 text-white'>Sakhi Designer Studio</h4>

                <hr />
                <ul className="socials">
                  <li>
                    <a href="https://wa.me/919324105995" className="social-button" target="_blank" aria-label="Whatsapp"><i className="fa fa-whatsapp" aria-hidden="true"></i></a>

                  </li>
                  <li>
                    <a href="https://www.instagram.com/sakhidesignerstudio/" target="_blank" className="social-button" aria-label="instagram"><i className="fa fa-instagram" aria-hidden="true"></i></a>

                  </li>
                  <li>
                    <a href="https://www.facebook.com/sakhistudio95?mibextid=ZbWKwL" target="_blank" className="social-button" aria-label="Facebook"><i className="fa fa-facebook" aria-hidden="true"></i></a>
                  </li>
                </ul>
              </div>
            </Col>

            <Col sm={12} xs={12} md={12} lg={8}>
              <Row className='pt-4'>
                {/* <Col sm={6} xs={6} lg={3} md={6}  className='links-footer'>
                  <p style={{ fontSize: '18px' }} className='mb-1'><strong>Category</strong></p>
                  <ul className='p-0'>
                    <li><Link to="" target='_blank' onClick={scrollToTop}>Kurtis</Link></li>
                    <li><Link to="" target='_blank' onClick={scrollToTop}>Lahenga Choli</Link></li>
                    <li><Link to="" target='_blank' onClick={scrollToTop}>Suits Stitched</Link></li>
                    <li><Link to="" target='_blank' onClick={scrollToTop}>Suits Unstitched</Link> </li>
                    <li><Link to="" target='_blank' onClick={scrollToTop}>Tunics</Link> </li>
                  </ul>
                </Col> */}
                <Col sm={6} xs={6} md={6} lg={3}  className='links-footer'>
                  <p style={{ fontSize: '18px' }} className='mb-1'><strong> Account</strong></p>
                  <ul className='p-0'>
                  <li><Link to="/contact" onClick={scrollToTop}>Contact Us</Link></li>
                    <li><Link to="" onClick={scrollToTop}>My account</Link></li>
                    <li><Link to="" onClick={scrollToTop}>My Orders</Link></li>
                    <li><Link to="" onClick={scrollToTop}>My Wishlist</Link></li>
                    <li><Link to="" onClick={scrollToTop}>Account details</Link></li>
           
                  </ul>
                </Col>

                <Col sm={6} xs={6} md={6} lg={3} className='links-footer'>
                  <p style={{ fontSize: '18px' }} className='mb-1'><strong> Information</strong></p>
                  <ul className='p-0'>
                    <li><Link to="/about" onClick={scrollToTop}>About</Link></li>
                    <li><Link to="" onClick={scrollToTop}>Disclaimer</Link></li>
                    <li><Link to="" onClick={scrollToTop}>Terms and Conditions</Link></li>              
 
                    <li><Link to="" onClick={scrollToTop}>Privacy Policy</Link></li>
                    <li><Link to="" onClick={scrollToTop}>Returns Policy</Link></li>
                  </ul>
                </Col>

                <Col sm={6} xs={12} md={6} lg={6}>
                  <p style={{ fontSize: '18px' }} className='mb-1'><strong>Address</strong></p>
                  <p style={{    fontSize: "15px"}}>Basement-L-105, Prime Mall, Near Alpha, Irla Society Road, Vile Parle West, Mumbai, Maharashtra 400056</p>
                  <p className='m-0'><strong>Connect with us</strong></p>
<p>
                  Phone: +91-9324105995,  022-26705995 <br />
                  Email: mamta_sakhi@yahoo.co.in</p>
                </Col>
              </Row>
            </Col>

          </Row>
        </div>
      </footer>

      <div className="copyright">
          {/* <Row>
            <Col sm={8}>©  2024 Sakhi. All Rights Reserved </Col>
            <Col sm={4} className="text-right">Powered by <a href="https://www.synques.in/" target='_blank'>SynQues</a></Col>
          </Row> */}
          <p className='text-center mb-0 text-white'>©  2026 Sakhi. All Rights Reserved | Powered by <a href="https://www.synques.in/" target='_blank' className='text-primery'> SynQues</a> </p>
  
      </div>
    </>
  );
}

export default Footer;
